import { useMemo } from 'react';
import SchoolYearsEditModal from './SchoolYearsEditModal';


export default function useSchoolYearsColumns({ schools, selectedSchools, setSelectedSchools, yearList, getSchoolsData }) {
    return useMemo(() => [
        {
          Header: ({column}) => (
            <div className='flex flex-col items-center justify-center mx-auto' onClick={(e) => e.stopPropagation()}>
              <span className='text-sm text-gray-500 w-12 text-center'>{selectedSchools?.length} / {schools?.length}</span>
            <input className='rounded-sm focus:ring-0 cursor-pointer' type='checkbox' checked={selectedSchools?.length === schools?.length && selectedSchools?.length > 0} onChange={(e) => {
              if (e.target.checked) {
                setSelectedSchools(schools?.map((school) => school.uuid));
              } else {
                setSelectedSchools([]);
              }
            }} />
            </div>
          ),
          id: 'select-all',
          Cell: (props) => (
            <div className='flex items-center justify-center' >
           <input className='rounded-sm focus:ring-0 cursor-pointer' type='checkbox' checked={selectedSchools?.includes(props.row.original.uuid)} onChange={(e) => {
            if (e.target.checked) {
              setSelectedSchools([...selectedSchools, props.row.original.uuid]);
            } else {
              setSelectedSchools((prev) => prev?.filter((school) => school !== props.row.original.uuid));
            }
    
           }} />
           </div>
          ),
        },{
          Header: 'ID',
          accessor: 'school_id',
        },{
          Header: 'Название',
          accessor: 'name',
        },
        {
          Header: 'Годы',
          accessor: 'years',
          Cell: (props) => {
            const years = yearList?.filter((y) => props.row.original?.years?.includes(y.uuid))?.map((y) => y.year)?.join(', ');
            return (
            <div className='px-4'>
              {years}
            </div>
          )},
        },
        {
          Header: 'Действия',
          accessor: 'actions',
          Cell: (props) => (
            <div className='text-center'>
              <SchoolYearsEditModal
                      school={props.row.original}
                      years={yearList}
                      getData={getSchoolsData}
                    />
            </div>
          ),
        },
      ], [schools, selectedSchools, getSchoolsData, yearList, setSelectedSchools]);
    
}